import { getPaymentLinkUrl } from './InsertPaymentLink';
import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentPopoverEmptyState = ({
  portalId
}) => /*#__PURE__*/_jsx(ContentPopoverEmptyState
// @ts-ignore ts-migrate FIXME
, {
  portalId: portalId,
  image: "payments",
  title: "hubspot-prosemirror.paymentLinks.popover.emptyState.title",
  description: "hubspot-prosemirror.paymentLinks.popover.emptyState.description",
  buttonLabel: "hubspot-prosemirror.paymentLinks.popover.emptyState.createPaymentLink",
  buttonLink: getPaymentLinkUrl(portalId)
});
export default PaymentPopoverEmptyState;